<div class="content">


        <mat-progress-bar class="pdf-loader-bar" mode="indeterminate">

        </mat-progress-bar>
    

</div>